import styled from 'styled-components';
import { HtmlTable } from '../../../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';

/**
 * Wraps HtmlTable to keep the row-label (first) column pinned while the strategy
 * columns scroll horizontally. The full-width "Category" header cell is also
 * pinned left so its label stays visible. Print skips the sticky behavior so it
 * doesn't interfere with PDF rendering, and uses tighter cell padding.
 *
 * The goal is for all 5 strategies to be comparable at a glance, so the columns
 * are sized to fit the ~1136px the page gives us (1200px module wrapper less its
 * 32px gutters). Scrolling stays as a fallback for narrow windows.
 */
export const StickyFirstColumnTable = styled(HtmlTable)<{ $isPrint?: boolean }>(
  ({ $isPrint, theme }) =>
    $isPrint
      ? {
          // Match HtmlTable's cell selectors so this wins over columnSpacing.
          '&& table thead tr th, && table thead tr td, && table tbody tr td': {
            padding: '4px 8px',
          },
        }
      : {
          overflowX: 'auto',

          // Auto table layout sizes columns by content, so the colgroup widths
          // are only hints. A min-width is needed to actually widen the column.
          'table td': {
            minWidth: 150,
          },

          // Wide enough for the longest row label without pushing the strategy
          // columns off screen.
          'table td:first-of-type': {
            minWidth: 190,
            position: 'sticky',
            left: 0,
            zIndex: 2,
            background: theme.colors.bg,
            boxShadow: `inset -1px 0 ${theme.colors.neutral[200]}`,
          },

          'table thead th': {
            background: theme.colors.neutral[100],
            textAlign: 'left',
          },

          // The "Category" cell spans the full table width, so the cell itself has
          // no room to stick. Pin its inner content (an inline-block) instead so
          // the label stays visible while the strategy columns scroll.
          'table thead th > *': {
            position: 'sticky',
            left: 16,
            display: 'inline-block',
          },
        },
);
